import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {IOrderDetail} from "../models/IOrderDetail";

function createData(
	name: string,
	value: string | null | undefined,
) {
	if (!value)
		value = "";
	return {name, value};
}

const StyledTableCell = styled(TableCell)(({theme}) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));
export function HealthData(props: { order: IOrderDetail }) {
	const order = props.order;
	if (!order.policyId || !order.package?.policyDetails)
		return (<div></div>);
	const rows: { name: string; value: string | null | undefined }[] = [];
	
	for (let i = 0; i < order.package.policyDetails.length; i++) {
		const item = order.package.policyDetails[i];
		if (item.coverageBasicHealths && item.coverageBasicHealths.length > 0) {
			const coverageBasicHealths = item.coverageBasicHealths[0];
			rows.push(createData("Basic DeductibleAmount", coverageBasicHealths.deductibleAmount?.toString()));
			rows.push(createData("Basic DeductibleDiscountAmount", coverageBasicHealths.deductibleDiscountAmount?.toString()));
		}
		
		if (item.coverageAdditionalHealths && item.coverageAdditionalHealths.length > 0) {
			const coverageAdditionalHealths = item.coverageAdditionalHealths[0];
			rows.push(createData("Additional DeductibleAmount", coverageAdditionalHealths.deductibleAmount?.toString()));
			rows.push(createData("Additional DeductibleDiscountAmount", coverageAdditionalHealths.deductibleDiscountAmount?.toString()));
		}
		
		if (item.coverageDentistHealths && item.coverageDentistHealths.length > 0) {
			const coverageDentistHealths = item.coverageDentistHealths[0];
			rows.push(createData("Dentist DeductibleAmount", coverageDentistHealths.deductibleAmount?.toString()));
			rows.push(createData("Dentist DeductibleDiscountAmount", coverageDentistHealths.deductibleDiscountAmount?.toString()));
		}
		
	}
	
	return (
		<TableContainer component={Paper}>
			<Table sx={{minWidth: 650}} size="small" aria-label="Health Care">
				<TableBody>
					{rows.map((row) => (
						<StyledTableRow
							key={row.name}
						>
							<StyledTableCell component="th" scope="row">
								{row.name}
							</StyledTableCell>
							<StyledTableCell align="right">{row.value}</StyledTableCell>
						</StyledTableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
	
}
